import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex min-w-40 items-center gap-[6px]',
    text: 'heading-xs md:heading-s -mt-[3px]',
    authButton: 'inline-block p-0 capitalize',
    markerIcon: 'color-blue-dark',
    infoIcon: 'color-icon-secondary cursor-pointer',
    info: '',
    infoTitle: 'heading-s-bold mb-2',
    infoText: 'heading-xs mb-3 max-w-70',
    infoLink:
      'heading-xs-bold flex items-center gap-2 font-semibold tracking-[0.06em] uppercase'
  },
  variants: {
    size: {
      xs: {
        text: 'heading-xs'
      },
      s: {
        text: 'heading-s'
      }
    }
  }
});
